import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=0bfb1878&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=0bfb1878&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfb1878",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bfb1878')) {
      api.createRecord('0bfb1878', component.options)
    } else {
      api.reload('0bfb1878', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=0bfb1878&scoped=true", function () {
      api.rerender('0bfb1878', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/header/Header.vue"
export default component.exports